import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight, FiClock, FiMapPin, FiUsers } = FiIcons;

const days = [
  {
    number: '01', weekday: 'SÁBADO', date: '14 NOV', title: 'Escuela de Liderazgo',
    venue: 'Hotel Fiesta Inn Plaza San Marcos', time: '13:30 a 18:00',
    audience: 'Abierto a todos los tabuladores, Equipos del Mundo y Equipos del Mundo Activo con boleto pagado',
    description: 'Liderazgo como influencia: cómo formar primeras líneas, por qué cuesta, y las tres formas de influir en la gente que diriges.'
  }
];

export default function EventDays() {
  return (
    <section className="section event-section" id="experiencia">
      <div className="container">
        <div className="section-top"><span className="eyebrow">01 / LA EXPERIENCIA</span><span className="section-rule" /></div>
        <div className="section-intro">
          <h2>Un día.<br /><span>Un entrenamiento.</span></h2>
          <p>Una tarde diseñada para elevar la forma en que lideras y formas a tu equipo.</p>
        </div>
        <div className="days-grid single">
          {days.map((day) => (
            <article className="day-card" key={day.number}>
              <div className="day-card-top"><span className="day-number">{day.number} / 01</span><SafeIcon icon={FiArrowUpRight} /></div>
              <div className="day-date"><strong>{day.date}</strong><span>{day.weekday}</span></div>
              <h3>{day.title}</h3>
              <p className="day-description">{day.description}</p>
              <div className="day-details">
                <span><SafeIcon icon={FiMapPin} /> {day.venue}</span>
                <span><SafeIcon icon={FiClock} /> {day.time}</span>
                <span><SafeIcon icon={FiUsers} /> {day.audience}</span>
              </div>
            </article>
          ))}
        </div>
        <div className="day-note"><span className="note-star">✳</span> Presenta tu confirmación de pago en la entrada <span className="note-small">Acceso y registro desde las 13:30.</span></div>
      </div>
    </section>
  );
}